import { z } from 'zod'
import { zId, zIsoDate } from '../common'

// One recorded POST /api/v1/admin/conversions/upload call. Makes the offline
// click-conversion upload loop observable: how many rows the affiliation
// platform pushed, how many Google accepted, and a per-action breakdown.
//
// `breakdown` is an open jsonb blob (internal snake_case preserved):
//   { actions: { "<conversionActionId>": { received, accepted, rejected } },
//     error?: "quota_exceeded: ..." }  // error present only on failed runs.
const zActionBreakdown = z.object({
  received: z.number().default(0),
  accepted: z.number().default(0),
  rejected: z.number().default(0),
})

export const zConversionUploadBreakdown = z.object({
  actions: z.record(zActionBreakdown).default({}),
  error: z.string().nullish(),
})
export type ConversionUploadBreakdown = z.infer<typeof zConversionUploadBreakdown>

export const zConversionUploadRun = z.object({
  id: zId,
  receivedCount: z.number(),
  acceptedCount: z.number(),
  rejectedCount: z.number(),
  // Parse defensively: an older/partial blob shouldn't fail the whole list.
  breakdown: z
    .unknown()
    .transform((value) => zConversionUploadBreakdown.safeParse(value ?? {}))
    .transform((result) => (result.success ? result.data : { actions: {} })),
  createdAt: zIsoDate,
})
export type ConversionUploadRun = z.infer<typeof zConversionUploadRun>
